import { ReactElement } from 'react';

import { IntegrationProfile } from '@dreryk/egabinet-adamed-expert-frontend-api';
import { EmailAddress } from '@dreryk/email-address-common-api';

import { FormContextValues, translateText, useFormController } from '@dreryk/react-common';
import { Checkbox, EmailAddressInput, PasswordInput, StyledFlex } from '@dreryk/react-components';

import { translationKeys } from './translations';

export type AdamedExpertAuthenticateFormBean = {
   emailAddress: EmailAddress | null;
   password: string | null;
   rememberMe: boolean;
};

export type AdamedExpertAuthenticateFormRendererProps = Pick<
   FormContextValues<AdamedExpertAuthenticateFormBean>,
   'handleSubmit' | 'formState'
>;

type AdamedExpertAuthenticateFormProps = {
   integrationProfile: IntegrationProfile;
   children: (rendererProps: AdamedExpertAuthenticateFormRendererProps) => ReactElement;
};

export const AdamedExpertAuthenticateForm = (props: AdamedExpertAuthenticateFormProps): JSX.Element => {
   const { register, handleSubmit, formState } = useFormController<AdamedExpertAuthenticateFormBean>({
      emailAddress: props.integrationProfile.emailAddress,
      rememberMe: props.integrationProfile.rememberMe,
   });
   return (
      <StyledFlex direction={'column'} gap={24}>
         <EmailAddressInput
            testId='emailAddress'
            label={translationKeys.modal.emailAddress}
            placeholder={translateText(translationKeys.modal.emailPlaceholder)}
            controller={register('emailAddress', {
               required: true,
            })}
         />
         <PasswordInput
            testId='password'
            label={translationKeys.modal.password}
            placeholder={translationKeys.modal.passwordPlaceholder}
            controller={register('password', {
               required: true,
            })}
         />
         <Checkbox testId={'rememberMe'} label={translationKeys.modal.rememberMe} controller={register('rememberMe')} />
         {props.children({ handleSubmit: handleSubmit, formState: formState })}
      </StyledFlex>
   );
};
